import React from "react";
import { DatePicker, Select, Space } from "antd";
const { RangePicker } = DatePicker;

const statusOptions = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

const FilterBar = ({
  filters,
  onChange,
  showDate,
  showDateRange,
  showStatus,
}) => {
  const handleChange = (changed) => {
    onChange({ ...filters, ...changed });
  };

  return (
    <Space style={{ marginBottom: 16 }} wrap>
      {showDate && (
        <DatePicker
          value={filters.createdDate || null}
          onChange={(date) => handleChange({ createdDate: date })}
        />
      )}
      {showDateRange && (
        <RangePicker
          value={
            filters.startDate && filters.endDate
              ? [filters.startDate, filters.endDate]
              : []
          }
          onChange={(dates) =>
            handleChange({
              startDate: dates ? dates[0] : null,
              endDate: dates ? dates[1] : null,
            })
          }
        />
      )}
      {showStatus && (
        <Select
          allowClear
          placeholder="Status"
          value={filters.status}
          options={statusOptions}
          onChange={(v) => handleChange({ status: v })}
          style={{ width: 120 }}
        />
      )}
    </Space>
  );
};

export default FilterBar;
